import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import type { AdminAddonsStateData } from "@/types/catalog"

export type AdminAddonsState = {
  data: AdminAddonsStateData
  error: string | null
}

export const adminAddonsInitialState: AdminAddonsState = {
  data: {
    addons: [],
    pagination: {
      pageNumber: 1,
      pageSize: 10,
      totalElements: 0,
      totalPages: 0,
    },
  },
  error: null,
}

const slice = createSlice({
  name: "adminAddons",
  initialState: adminAddonsInitialState,
  reducers: {
    setAdminAddonsAction(state, { payload }: PayloadAction<AdminAddonsStateData>) {
      state.data = payload
      state.error = null
    },
    setAdminAddonsErrorAction(state, { payload }: PayloadAction<string | null>) {
      state.error = payload
    },
  },
})

export const { setAdminAddonsAction, setAdminAddonsErrorAction } = slice.actions
export default slice.reducer
